import React, { useState, useEffect } from 'react';
import LoginForm from './components/LoginForm';
import { login, validateSession } from './adminSession';

// Standalone admin login at /admin, so the public site carries no admin UI.
// On success it returns to the home page, where the edit controls appear
// because the token is already in localStorage.
function AdminLogin() {
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    document.title = 'Admin Login | Vivat Alfa Winery';

    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex, nofollow';
    document.head.appendChild(robots);

    // Already signed in? There is nothing to do here.
    validateSession().then((valid) => {
      if (valid) window.location.replace('/');
      else setChecking(false);
    });

    return () => { document.head.removeChild(robots); };
  }, []);

  const handleSubmit = async (username, password) => {
    setError('');
    const result = await login(username, password);
    if (result.ok) window.location.replace('/');
    else setError(result.message);
  };

  return (
    <div
      className="flex items-center justify-center px-6 py-10"
      style={{ minHeight: '100vh', backgroundColor: '#722f37' }}
    >
      <main className="w-full" style={{ maxWidth: '26rem' }}>
        <div className="text-center mb-8">
          <img
            src="/logo-mark.png"
            alt=""
            aria-hidden="true"
            className="mx-auto mb-3"
            style={{ height: '4rem', width: 'auto' }}
          />
          <h1 className="text-white text-3xl font-bold">Vivat Alfa Winery</h1>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-2xl font-bold text-wine mb-6 text-center">Admin Login</h2>

          {checking ? (
            <p className="text-center text-gray-500 py-6">Checking your session...</p>
          ) : (
            <LoginForm onSubmit={handleSubmit} error={error} autoFocus />
          )}
        </div>

        <p className="text-center mt-6">
          <a href="/" className="text-gold hover:text-white transition">
            <span aria-hidden="true">←</span> Back to the website
          </a>
        </p>
      </main>
    </div>
  );
}

export default AdminLogin;
